(function () {
  if (window.CleerdentPreorder && window.CleerdentPreorder.initialized) return;

  var controllers = [];

  function parseConfig(script) {
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('[Cleerdent preorder] Unable to read variant preorder data.', error);
      return null;
    }
  }

  function normalizeVariantId(value) {
    if (value === null || typeof value === 'undefined') return '';
    return String(value);
  }

  function getDetailVariantId(detail) {
    if (!detail) return '';
    if (detail.currentVariant && detail.currentVariant.id) return normalizeVariantId(detail.currentVariant.id);
    if (detail.variant && detail.variant.id) return normalizeVariantId(detail.variant.id);
    return normalizeVariantId(detail.variantId || detail.variant_id || detail.id || '');
  }

  function getInputVariantId(root) {
    var selectors = [
      'form[data-type="add-to-cart-form"] input[name="id"]',
      '.t4s-product-form__variants input[name="id"]',
      '[data-cd-pdp-variant-input]',
      '[data-cd-tb-variant-input]',
      '[data-cd-refill-variant-input]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var inputs = root.querySelectorAll(selectors[i]);
      for (var j = 0; j < inputs.length; j += 1) {
        if (inputs[j].value) return normalizeVariantId(inputs[j].value);
      }
    }

    return '';
  }

  function getActiveSwatchVariantId(root) {
    var active = root.querySelector(
      '.is-active[data-variant-id], .is-active[data-cd-tb-variant], .is-active[data-cd-refill-variant]'
    );
    if (!active) return '';
    return normalizeVariantId(
      active.getAttribute('data-variant-id') ||
      active.getAttribute('data-cd-tb-variant') ||
      active.getAttribute('data-cd-refill-variant') ||
      ''
    );
  }

  function getUrlVariantId() {
    try {
      return normalizeVariantId(new URL(window.location.href).searchParams.get('variant') || '');
    } catch (error) {
      return '';
    }
  }

  function setLabel(element, text) {
    if (!element) return;
    if ((element.textContent || '').trim() !== text) element.textContent = text;
  }

  function Controller(script) {
    this.script = script;
    this.config = parseConfig(script);
    this.root = document.getElementById(script.getAttribute('data-root-id'));
    this.currentVariantId = '';
    this.pendingFrame = 0;
    this.observer = null;
  }

  Controller.prototype.hasVariant = function (variantId) {
    return !!(variantId && this.config && this.config.variants && this.config.variants[variantId]);
  };

  Controller.prototype.resolveVariantId = function (preferredId) {
    var candidates = [
      normalizeVariantId(preferredId),
      getInputVariantId(this.root),
      getActiveSwatchVariantId(this.root),
      getUrlVariantId(),
      normalizeVariantId(this.config.currentVariantId)
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      if (this.hasVariant(candidates[i])) return candidates[i];
    }
    return '';
  };

  Controller.prototype.apply = function (preferredId) {
    var variantId = this.resolveVariantId(preferredId || this.currentVariantId);
    if (!variantId) return;

    var variant = this.config.variants[variantId];
    var available = variant.available !== false;
    var isPreorder = available && variant.preorder === true;
    var preorderLabel = this.config.preorderLabel || 'Pre-Order';
    var addToCartLabel = this.config.addToCartLabel || 'Add to cart';
    var soldOutLabel = this.config.soldOutLabel || 'Sold out';

    this.currentVariantId = variantId;
    this.root.setAttribute('data-cd-current-variant-id', variantId);
    this.root.setAttribute('data-cd-current-variant-preorder', isPreorder ? 'true' : 'false');

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-cd-preorder-label]'), function (element) {
      var defaultLabel = element.getAttribute('data-cd-preorder-default-label') || addToCartLabel;
      var label = available ? (isPreorder ? preorderLabel : defaultLabel) : soldOutLabel;
      setLabel(element, label);
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-cd-preorder-message]'), function (element) {
      var message = variant.availabilityText || '';
      if ((element.textContent || '').trim() !== message) element.textContent = message;
      element.hidden = !message;
      element.setAttribute('aria-hidden', message ? 'false' : 'true');
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-cd-preorder-status]'), function (element) {
      element.classList.toggle('t4s-dn', !isPreorder);
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-cd-instock-status]'), function (element) {
      element.classList.toggle('t4s-dn', !available || isPreorder);
    });

    this.root.dispatchEvent(new CustomEvent('cleerdent:preorder-change', {
      bubbles: true,
      detail: {
        variantId: variantId,
        available: available,
        preorder: isPreorder,
        availabilityText: variant.availabilityText || ''
      }
    }));
  };

  Controller.prototype.queue = function (preferredId) {
    var controller = this;
    if (preferredId && this.hasVariant(normalizeVariantId(preferredId))) {
      this.currentVariantId = normalizeVariantId(preferredId);
    }
    if (this.pendingFrame) window.cancelAnimationFrame(this.pendingFrame);
    this.pendingFrame = window.requestAnimationFrame(function () {
      controller.pendingFrame = 0;
      controller.apply(controller.currentVariantId);
    });
  };

  Controller.prototype.bind = function () {
    var controller = this;
    if (!this.config || !this.root || this.script.dataset.cdPreorderBound === 'true') return false;
    this.script.dataset.cdPreorderBound = 'true';

    this.root.addEventListener('input', function (event) {
      if (event.target && event.target.matches && event.target.matches('input[name="id"]')) {
        controller.queue(event.target.value);
      }
    }, true);

    this.root.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('input[name="id"], select[name="id"]')) {
        controller.queue(event.target.value);
      } else {
        controller.queue();
      }
    }, true);

    this.root.addEventListener('click', function () {
      window.setTimeout(function () { controller.queue(); }, 0);
      window.setTimeout(function () { controller.queue(); }, 90);
      window.setTimeout(function () { controller.queue(); }, 240);
    }, true);

    ['variant:change', 'variant:changed'].forEach(function (eventName) {
      controller.root.addEventListener(eventName, function (event) {
        controller.queue(getDetailVariantId(event.detail));
      });
    });

    if (window.MutationObserver) {
      this.observer = new MutationObserver(function (mutations) {
        var shouldSync = mutations.some(function (mutation) {
          var node = mutation.target && mutation.target.nodeType === 1
            ? mutation.target
            : mutation.target && mutation.target.parentElement;
          return !!(node && node.closest && node.closest('[data-cd-preorder-label], [data-cd-preorder-message]'));
        });
        if (shouldSync) controller.queue();
      });
      this.observer.observe(this.root, { subtree: true, childList: true, characterData: true });
    }

    this.apply();
    return true;
  };

  function bindScript(script) {
    if (!script || script.dataset.cdPreorderBound === 'true') return;
    var controller = new Controller(script);
    if (controller.bind()) controllers.push(controller);
  }

  function init(context) {
    var scope = context && context.querySelectorAll ? context : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cd-preorder-data]'), bindScript);
    if (scope.matches && scope.matches('[data-cd-preorder-data]')) bindScript(scope);
  }

  function handleVariantEvent(event) {
    var variantId = getDetailVariantId(event.detail);
    controllers.forEach(function (controller) {
      if (controller.hasVariant(variantId)) controller.queue(variantId);
    });
  }

  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('variant:changed', handleVariantEvent);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers = controllers.filter(function (controller) {
      var remove = !!(event.target && event.target.contains(controller.script));
      if (remove && controller.observer) controller.observer.disconnect();
      return !remove;
    });
  });

  window.CleerdentPreorder = {
    initialized: true,
    init: init,
    refresh: function () {
      controllers.forEach(function (controller) { controller.queue(); });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
